import { noop } from "common/functions";
import { delay } from "common/promises";
import { onVideoTime } from "common/video";
import { load } from "first-animation/loader";
import { Scene } from "first-animation/scene/main";
import log from "loglevel";
import { Param } from "../common";
export async function start({ context, input, }) {
    const sound = await load({
        progressCallback: noop,
    });
    const { videoElem, progressElem } = await input.waiter.wait();
    videoElem.setAttribute("id", "interaction-video");
    $(videoElem).removeClass("flip-card-back");
    $("#resizer").append(videoElem);
    $("#resizer").append(progressElem);
    $(videoElem).hide();
    context.interactionVideoLoader.clearMovie("1번 영상.mp4");
    context.interactionVideoLoader.runWhenLoaded("2번 영상.mp4", async (elem) => {
        log.info("second video loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    const scene = new Scene();
    await scene.start({ sound, parentSelector: "#all-container" });
    sound.dispose();
    log.debug("둘째 영상 기다리기");
    await context.interactionVideoLoader.wait("2번 영상.mp4");
    log.debug("둘째 영상 기다리기 완료");
    $(progressElem).show();
    $(videoElem).show();
    await videoElem.play();
    progressElem.run({ index: 2, video: videoElem });
    const ret = new Param();
    onVideoTime({
        videoElement: videoElem,
        timeMillis: (videoElem.duration - 1) * 1000,
        callback: () => {
            progressElem.fadeOutAndHide();
        },
    });
    $(videoElem).one("ended", () => {
        ret.fill({ videoElem, progressElem });
    });
    return ret;
}
export async function skippedStart({ context, input, waitVideo, }) {
    const { videoElem, progressElem } = await input.waiter.wait();
    log.debug("first interaction video is loaded");
    videoElem.setAttribute("id", "interaction-video");
    $("#resizer").append(videoElem);
    $("#resizer").append(progressElem);
    $(videoElem).hide();
    context.interactionVideoLoader.runWhenLoaded("2번 영상.mp4", async (elem) => {
        log.info("second video loaded elem is ", elem);
        videoElem.setAttribute("src", elem.src);
        videoElem.load();
    });
    log.debug("둘째 영상 기다리기");
    await context.interactionVideoLoader.wait("2번 영상.mp4");
    log.debug("둘째 영상 기다리기 완료");
    $(videoElem).show();
    $(progressElem).show();
    await videoElem.play();
    progressElem.run({ index: 2, video: videoElem });
    const ret = new Param();
    if (waitVideo) {
        await delay(1000);
        videoElem.currentTime = videoElem.duration - 4;
        onVideoTime({
            videoElement: videoElem,
            timeMillis: (videoElem.duration - 1) * 1000,
            callback: () => {
                progressElem.fadeOutAndHide();
            },
        });
        $(videoElem).one("ended", () => {
            ret.fill({ videoElem, progressElem });
        });
    }
    else {
        ret.fill({ videoElem, progressElem });
    }
    return ret;
}
//# sourceMappingURL=main.js.map